module.exports = __webpack_public_path__ + "static/media/cover-products.1e9cecb4.png";